import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialUiModule } from '@cpd-app/shared-module/material-ui-module/material-ui.module';
import { ButtonModule } from '../button/button.module';

import { DialogContainerComponent } from './dialog-container/dialog-container.component';
import { DialogContainer2Component } from './dialog-container2/dialog-container2.component';

const components = [DialogContainerComponent, DialogContainer2Component];

@NgModule({
  imports: [CommonModule, MaterialUiModule, ButtonModule],
  declarations: [...components],
  exports: [...components]
})
export class DialogModule {}
